var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('AdminTableContainer', {
    attrs: {
      "users": _vm.localUsers,
      "headers": _vm.headers,
      "options": _vm.options
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small mb-4 text-danger"
  }, [_vm._v("By selecting \"Onboard without payment\" users will be uploaded into our system, but they won't have full access to SpNOD until a plan is added in the future!")]), _vm._v(" "), _c('b-row', {
    staticClass: "d-flex justify-content-between px-2"
  }, [_c('b-form-group', [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        Back\n      ")])], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end flex-grow"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [(!_vm.isSaving) ? _c('p', [_vm._v("Onboard without payment")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [(!_vm.isSubmitting) ? _c('p', [_vm._v("Payment")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e8df22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/BulkUpload/ReviewBulkUpload.vue
// module id = SoLQ
// module chunks = 2